/**
 * Global Admin Plugin UI class
 */
// Import all UI related scripts
import theme from 'porto-admin/build/script/theme';
import modal from './ui/modal';
import campaign_fields from './components/campaign_fields';
import collections from './components/collections';
import form from './components/forms';
import codesUpload from './components/codes_upload';
import addressCompletionSettings from './components/address_completion_settings';
import paymentProviders from './components/payment_providers';
import registrantInput from '../../../../../build/script/src/components/registrant_input';

// Require any extra porto admin plugins related to UI
require('porto-admin/HTML/vendor/select2/js/select2');
require('porto-admin/HTML/vendor/bootstrap-timepicker/bootstrap-timepicker');
require('porto-admin/HTML/vendor/jquery-matchheight/jquery.matchheight');
require('porto-admin/HTML/vendor/bootstrap-fileupload/bootstrap-fileupload.min');
require('expose-loader?CodeMirror!porto-admin/HTML/vendor/CodeMirror/lib/codemirror');
require('porto-admin/HTML/vendor/CodeMirror/addon/selection/active-line');
require('porto-admin/HTML/vendor/CodeMirror/addon/edit/matchbrackets');
require('porto-admin/HTML/vendor/CodeMirror/mode/javascript/javascript');
require('porto-admin/HTML/vendor/CodeMirror/mode/xml/xml');
require('porto-admin/HTML/vendor/CodeMirror/mode/htmlmixed/htmlmixed');
require('porto-admin/HTML/vendor/CodeMirror/mode/css/css');
require('porto-admin/HTML/vendor/summernote/summernote-bs4');
require('expose-loader?autosize!porto-admin/HTML/vendor/autosize/autosize');
require('porto-admin/HTML/vendor/bootstrap-colorpicker/js/bootstrap-colorpicker');
require('porto-admin/HTML/vendor/dropzone/dropzone');
require('porto-admin/HTML/vendor/morris/morris');
require('porto-admin/HTML/vendor/nanoscroller/nanoscroller');
require('expose-loader?Raphael!porto-admin/HTML/vendor/raphael/raphael');

/**
 * Initialize a container of HTML
 * @param {jQuery} $container
 */
const initializeContainer = function($container) {
    theme.initializeContainer($container);
    modal.initializeContainer($container);
    campaign_fields.initializeContainer($container);
    collections.initializeContainer($container);
    form.initializeContainer($container);
    codesUpload.initializeContainer($container);
    addressCompletionSettings.initializeContainer($container);
    registrantInput.initializeContainer($container);
    paymentProviders.initializeContainer($container);

    // Match height
    $container.find('[data-match-height]').matchHeight({remove: true});

    // Initialize tooltips
    $container.find('[data-toggle="tooltip"]').tooltip({html: true});

    $container.find('a[href^="/"], a[data-load-contentbody]').filter(':not([data-no-load]):not(.modal-ajax)').click(function(evt) {
        // Middle click, cmd click, and ctrl click
        if (evt.which > 1 || evt.metaKey || evt.ctrlKey || evt.shiftKey || evt.altKey) {
            return;
        }

        // Ignore target with _blank target
        if (this.target && this.target === '_blank') {
            return;
        }

        let $contentBody = $('section.content-body[data-loading-overlay]');
        if ($contentBody.length > 0) {
            modal.closeAll();
            $contentBody.addClass('loading-overlay-showing');
        }
    });

    // Dropzone appended data
    $container.find('.dropzone').each(function() {
        let appendedData = $(this).data('append');
        if (appendedData !== undefined) {
            $(this).dropzone()[0].dropzone.on('sending', function(file, xhr, formData) {
                Object.keys(appendedData).forEach(function(key) {
                    formData.append(key, appendedData[key]);
                });
            });
        }
    });

    // Ensure expanding / collapsing within a data-match-height container is functional
    $container.find('[data-toggle="collapse"]').on('click', function() {
        minMatchHeight($(this));
    });
    // Ensure selection on multiple rows within a data-match-height container follows
    $container.find('select[multiple]').on('change', function() {
        minMatchHeight($(this));
    });
};

/**
 * Ensure the match height container in which this element sits is converted to minimum height
 * @param {jQuery} $element
 */
const minMatchHeight = function($element) {
    let $matchHeightContainer = $element.closest('[data-match-height]');
    if ($matchHeightContainer.length === 0 || $matchHeightContainer.attr('style') === undefined) {
        return;
    }
    if ($matchHeightContainer.attr('style').indexOf('min-height') === -1) {
        const height = $matchHeightContainer.css('height');
        $matchHeightContainer.css({height: 'auto', 'min-height': height});
    }
};

// Export initialization
export default {
    initializeContainer: initializeContainer,
    initialize:          function() {
        // Initialize any other ui related modules
        modal.initialize();

        // Initialize registrant input for enum fields
        registrantInput.initialize();

        // Initialize the body as a container
        let $body = $('body');
        this.initializeContainer($body);

        // Initialize using the theme skeleton
        window.theme.Skeleton.initialize();
    },
};



// WEBPACK FOOTER //
// ./plugins/Admin/build/script/src/ui.js